var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _defs, _g18, _defs2, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _defs3, _g27, _defs4, _g28, _g29, _g30, _g31, _g32, _g33, _animate, _animate2, _animate3, _animate4, _animate5, _animate6, _animate7, _animate8, _animate9, _animate10, _animate11, _animate12, _animate13, _animate14, _animate15, _animate16, _animate17, _animate18, _animate19, _animate20, _animate21, _animate22, _animate23, _animate24, _animate25, _animate26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrioritizationMotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "m6eyq04n94617384",
    viewBox: "0 0 420 250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq04n94617384_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq04n94617384",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq04p53127014_mask",
    style: {
      maskType: "alpha"
    },
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq04p53127014_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq04p53127014",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq04p53127014_fill_path",
    d: "M0.01,0h419.98c0.00552,0 0.01,0.00448 0.01,0.01v249.98c0,0.00552 -0.00448,0.01 -0.01,0.01h-419.98c-0.00552,0 -0.01,-0.00448 -0.01,-0.01v-249.98c0,-0.00552 0.00448,-0.01 0.01,-0.01z",
    fillRule: "nonzero",
    fill: "rgb(255, 218, 187)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#m6eyq04p53127014_mask)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq04s46402603_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-146.4779,-208.6396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq04s46402603",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq04s17742425_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,45.3731)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq04s17742425",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq04t69453872_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.459,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq04t69453872",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq04t69453872_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq04t69453872_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6eyq04t69453872ps0)",
    mask: "url(#m6eyq04t69453872_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq04v08503244_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4567,323.5301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq04v08503244",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq04v08503244_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq04v08503244_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6eyq04v08503244ps0)",
    mask: "url(#m6eyq04v08503244_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq04w27630957_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4567,200.9696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq04w27630957",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq04w27630957_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq04w27630957_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6eyq04w27630957ps0)",
    mask: "url(#m6eyq04w27630957_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq04x32260849_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.5341,262.5546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq04x32260849",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq04x32260849_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq04x32260849_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6eyq04x32260849ps0)",
    mask: "url(#m6eyq04x32260849_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq04y22074730_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4567,68.0587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq04y22074730",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq04y22074730_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq04y22074730_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6eyq04y22074730ps0)",
    mask: "url(#m6eyq04y22074730_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq04z39314143_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.5341,387.5546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq04z39314143",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq04z39314143_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq04z39314143_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6eyq04z39314143ps0)",
    mask: "url(#m6eyq04z39314143_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05072660264_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4567,140.6513)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05072660264",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05072660264_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq05072660264_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6eyq05072660264ps0)",
    mask: "url(#m6eyq05072660264_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05140433049_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4567,417.4169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05140433049",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05140433049_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq05140433049_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6eyq05140433049ps0)",
    mask: "url(#m6eyq05140433049_gradient_mask)"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05393203320_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,92.6772,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05393203320",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05316002630_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,187.6007,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05316002630",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05316002630_stroke_path",
    d: "M0,0v576.21948",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq05316002630_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,575.21948)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -576.8195000000001,
    width: 1.7999999999999998,
    height: 1730.4585000000002,
    fill: "url(#m6eyq05316002630ps0)",
    mask: "url(#m6eyq05316002630_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05486504149_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,430.6007,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05486504149",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05486504149_stroke_path",
    d: "M0,0v576.21948",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq05486504149_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,575.21948)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -576.8195000000001,
    width: 1.7999999999999998,
    height: 1730.4585000000002,
    fill: "url(#m6eyq05486504149ps0)",
    mask: "url(#m6eyq05486504149_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05540449280_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05540449280",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05540449280_stroke_path",
    d: "M0,0v576.21948",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq05540449280_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,575.21948)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -576.8195000000001,
    width: 1.7999999999999998,
    height: 1730.4585000000002,
    fill: "url(#m6eyq05540449280ps0)",
    mask: "url(#m6eyq05540449280_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05651436804_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,268.6007,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05651436804",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05651436804_stroke_path",
    d: "M0,0v576.21948",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq05651436804_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,575.21948)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -576.8195000000001,
    width: 1.7999999999999998,
    height: 1730.4585000000002,
    fill: "url(#m6eyq05651436804ps0)",
    mask: "url(#m6eyq05651436804_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05758850283_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,349.6007,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05758850283",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05758850283_stroke_path",
    d: "M0,0v576.21948",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq05758850283_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,575.21948)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -576.8195000000001,
    width: 1.7999999999999998,
    height: 1730.4585000000002,
    fill: "url(#m6eyq05758850283ps0)",
    mask: "url(#m6eyq05758850283_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05722654777_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,106.404,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05722654777",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05722654777_stroke_path",
    d: "M0,0v576.21948",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq05722654777_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,575.21948)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -576.8195000000001,
    width: 1.7999999999999998,
    height: 1730.4585000000002,
    fill: "url(#m6eyq05722654777ps0)",
    mask: "url(#m6eyq05722654777_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05837988497_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,525.1618,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05837988497",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05837988497_stroke_path",
    d: "M0,0v576.21948",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq05837988497_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,575.21948)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -576.8195000000001,
    width: 1.7999999999999998,
    height: 1730.4585000000002,
    fill: "url(#m6eyq05837988497ps0)",
    mask: "url(#m6eyq05837988497_gradient_mask)"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6ezn4az22456317_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,360.9779,307.6396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6ezn4az22456317",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6ezn4az22456317_stroke_path",
    d: "M81.5,0h-81.5",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6ezn4az22456317_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -83.5,
    y: -2,
    width: 250.5,
    height: 6,
    fill: "url(#m6ezn4az22456317ps0)",
    mask: "url(#m6ezn4az22456317_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6ezdnar98836800_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,198.9779,246.6396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6ezdnar98836800",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6ezdnar98836800_stroke_path",
    d: "M0,59.5c0,0 0,-40.3799 0,-42.7c0,-2.3201 0.3915,-4.2857 1.2785,-6.4294c0.887,-2.1437 2.0008,-3.8085 3.6422,-5.4499c1.6414,-1.6414 3.3062,-2.7552 5.4499,-3.6422c2.1437,-0.887 4.1093,-1.2785 6.4294,-1.2785c2.3201,0 63.7,0 63.7,0",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6ezdnar98836800_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -82.5,
    y: -61.5,
    width: 247.5,
    height: 184.5,
    fill: "url(#m6ezdnar98836800ps0)",
    mask: "url(#m6ezdnar98836800_gradient_mask)"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05a56317117_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,209.2002,7.8244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05a56317117",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05a56317117_fill_path",
    d: "M26.8913,0h122.7028c14.85165,0 26.8913,12.03965 26.8913,26.8913v0c0,14.85165 -12.03965,26.8913 -26.8913,26.8913h-122.7028c-14.85165,0 -26.8913,-12.03965 -26.8913,-26.8913v0c0,-14.85165 12.03965,-26.8913 26.8913,-26.8913z",
    fillRule: "nonzero",
    fill: "rgb(0, 48, 139)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6eyq05a56317117_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05a56317117_stroke_path",
    d: "M26.8913,0h122.7028c14.85165,0 26.8913,12.03965 26.8913,26.8913v0c0,14.85165 -12.03965,26.8913 -26.8913,26.8913h-122.7028c-14.85165,0 -26.8913,-12.03965 -26.8913,-26.8913v0c0,-14.85165 12.03965,-26.8913 26.8913,-26.8913z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6eyq05a56317117_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05a56317117_stroke_path",
    d: "M26.8913,0h122.7028c14.85165,0 26.8913,12.03965 26.8913,26.8913v0c0,14.85165 -12.03965,26.8913 -26.8913,26.8913h-122.7028c-14.85165,0 -26.8913,-12.03965 -26.8913,-26.8913v0c0,-14.85165 12.03965,-26.8913 26.8913,-26.8913z",
    fill: "none",
    stroke: "rgb(222, 84, 105)",
    strokeWidth: 0.783,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq05a56317117_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -177.26839999999999,
    y: -54.5656,
    width: 531.8052,
    height: 163.6968,
    fill: "url(#m6eyq05a56317117ps0)",
    mask: "url(#m6eyq05a56317117_gradient_mask)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05a27702208_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,15.661,16.0913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05a27702208",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05a61788960_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05a61788960",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6eyq05a61788960_clipPath",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05a61788960_fill_path",
    d: "M0.01,0h21.58c0.00552,0 0.01,0.00448 0.01,0.01v21.58c0,0.00552 -0.00448,0.01 -0.01,0.01h-21.58c-0.00552,0 -0.01,-0.00448 -0.01,-0.01v-21.58c0,-0.00552 0.00448,-0.01 0.01,-0.01z",
    fill: "white",
    clipRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6eyq05a61788960_clipPath)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05v94926653_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05v94926653",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null)))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05w41832698_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10.8,6.382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05w41832698",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05w41832698_stroke_path",
    d: "M0,7.85455v0.24545 M0,0v4.90909",
    fill: "none",
    stroke: "rgb(222, 84, 105)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq05w41832698_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,0,7.85455)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0,8.1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,0,0)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0,4.90909)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -2.4,
    y: -10.5,
    width: 7.199999999999999,
    height: 31.5,
    fill: "url(#m6eyq05w41832698ps0)",
    mask: "url(#m6eyq05w41832698_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05x05720948_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,2.6936,2.6713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05x05720948",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05x05720948_stroke_path",
    d: "M1.80632,14.42858h12.6c0.29368,-0.00206 0.58239,-0.07595 0.84095,-0.21521c0.25856,-0.13927 0.47912,-0.33969 0.64244,-0.58377c0.16332,-0.24409 0.26443,-0.52443 0.29451,-0.81656c0.03009,-0.29214 -0.01176,-0.5872 -0.1219,-0.85945l-6.39,-11.025c-0.15566,-0.28134 -0.38384,-0.51585 -0.66082,-0.67915c-0.27698,-0.1633 -0.59264,-0.24943 -0.91418,-0.24943c-0.32153,0 -0.6372,0.08613 -0.91418,0.24943c-0.27698,0.1633 -0.50516,0.39781 -0.66082,0.67915l-6.39,11.025c-0.10805,0.26602 -0.1509,0.55402 -0.12496,0.83998c0.02594,0.28595 0.1199,0.56155 0.27405,0.80379c0.15415,0.24224 0.36401,0.44408 0.61207,0.58869c0.24805,0.1446 0.5271,0.22777 0.81385,0.24255",
    fill: "none",
    stroke: "rgb(222, 84, 105)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq05x05720948_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,1.80632,14.42858)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(0.9986742924500837,0.05147482490815086,-0.05147482490815086,0.9986742924500837,1.70733,14.4286)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -18.5937,
    y: -16.828599999999998,
    width: 55.781099999999995,
    height: 50.4858,
    fill: "url(#m6eyq05x05720948ps0)",
    mask: "url(#m6eyq05x05720948_gradient_mask)"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05d93504239_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,36.1634,1.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05d93504239",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05d93504239_fill_path",
    d: "M8.44738,4.66l-3.132,8.34h-1.584l-3.144,-8.34h1.464l2.47201,6.936l2.484,-6.936zM15.5794,6.388v6.612h-1.368v-0.78c-0.216,0.272 -0.5,0.488 -0.852,0.648c-0.344,0.152 -0.712,0.228 -1.104,0.228c-0.52,0 -0.988,-0.108 -1.404,-0.324c-0.408,-0.216 -0.732,-0.536 -0.97199,-0.96c-0.232,-0.424 -0.348,-0.936 -0.348,-1.536v-3.888h1.35599v3.684c0,0.592 0.148,1.048 0.444,1.368c0.296,0.312 0.7,0.468 1.212,0.468c0.512,0 0.916,-0.156 1.212,-0.468c0.304,-0.32 0.456,-0.776 0.456,-1.368v-3.684zM18.7524,4.12v8.88h-1.368v-8.88zM23.8844,6.28c0.52,0 0.984,0.108 1.392,0.324c0.416,0.216 0.74,0.536 0.972,0.96c0.232,0.424 0.348,0.936 0.348,1.536v3.9h-1.356v-3.696c0,-0.592 -0.148,-1.044 -0.444,-1.356c-0.296,-0.32 -0.7,-0.48 -1.212,-0.48c-0.512,0 -0.92,0.16 -1.224,0.48c-0.296,0.312 -0.444,0.764 -0.444,1.356v3.696h-1.368v-6.612h1.368v0.756c0.224,-0.272 0.508,-0.484 0.852,-0.636c0.352,-0.152 0.724,-0.228 1.116,-0.228zM34.4014,9.532c0,0.248 -0.016,0.472 -0.048,0.672h-5.052c0.04,0.528 0.236,0.952 0.588,1.272c0.352,0.32 0.784,0.48 1.296,0.48c0.736,0 1.256,-0.308 1.56,-0.924h1.476c-0.2,0.608 -0.564,1.108 -1.092,1.5c-0.52,0.384 -1.168,0.576 -1.944,0.576c-0.632,0 -1.2,-0.14 -1.704,-0.42c-0.496,-0.288 -0.888,-0.688 -1.176,-1.2c-0.28,-0.52 -0.42,-1.12 -0.42,-1.8c0,-0.68 0.136,-1.276 0.408,-1.788c0.28,-0.52 0.668,-0.92 1.164,-1.2c0.504,-0.28 1.08,-0.42 1.728,-0.42c0.624,0 1.18,0.136 1.668,0.408c0.488,0.272 0.868,0.656 1.14,1.152c0.272,0.488 0.408,1.052 0.408,1.692zM32.9734,9.1c-0.008,-0.504 -0.188,-0.908 -0.54,-1.212c-0.352,-0.304 -0.788,-0.456 -1.308,-0.456c-0.472,0 -0.876,0.152 -1.212,0.456c-0.336,0.296 -0.536,0.7 -0.6,1.212zM37.1157,7.348c0.2,-0.336 0.464,-0.596 0.792,-0.78c0.336,-0.192 0.732,-0.288 1.188,-0.288v1.416h-0.348c-0.536,0 -0.944,0.136 -1.224,0.408c-0.272,0.272 -0.408,0.744 -0.408,1.416v3.48h-1.368v-6.612h1.368zM39.8971,9.664c0,-0.664 0.136,-1.252 0.408,-1.764c0.28,-0.512 0.656,-0.908 1.128,-1.188c0.48,-0.288 1.008,-0.432 1.584,-0.432c0.52,0 0.972,0.104 1.356,0.312c0.392,0.2 0.704,0.452 0.936,0.756v-0.96h1.38v6.612h-1.38v-0.984c-0.232,0.312 -0.548,0.572 -0.948,0.78c-0.4,0.208 -0.856,0.312 -1.368,0.312c-0.568,0 -1.088,-0.144 -1.56,-0.432c-0.472,-0.296 -0.848,-0.704 -1.128,-1.224c-0.272,-0.528 -0.408,-1.124 -0.408,-1.788zM45.3091,9.688c0,-0.456 -0.096,-0.852 -0.288,-1.188c-0.184,-0.336 -0.428,-0.592 -0.732,-0.768c-0.304,-0.176 -0.632,-0.264 -0.984,-0.264c-0.352,0 -0.68,0.088 -0.984,0.264c-0.304,0.168 -0.552,0.42 -0.744,0.756c-0.184,0.328 -0.276,0.72 -0.276,1.176c0,0.456 0.092,0.856 0.276,1.2c0.192,0.344 0.44,0.608 0.744,0.792c0.312,0.176 0.64,0.264 0.984,0.264c0.352,0 0.68,-0.088 0.984,-0.264c0.304,-0.176 0.548,-0.432 0.732,-0.768c0.192,-0.344 0.288,-0.744 0.288,-1.2zM49.8539,7.372c0.232,-0.32 0.548,-0.58 0.948,-0.78c0.408,-0.208 0.86,-0.312 1.356,-0.312c0.584,0 1.112,0.14 1.584,0.42c0.472,0.28 0.844,0.68 1.116,1.2c0.272,0.512 0.408,1.1 0.408,1.764c0,0.664 -0.136,1.26 -0.408,1.788c-0.272,0.52 -0.648,0.928 -1.128,1.224c-0.472,0.288 -0.996,0.432 -1.572,0.432c-0.512,0 -0.968,-0.1 -1.368,-0.3c-0.392,-0.2 -0.704,-0.456 -0.936,-0.768v0.96h-1.368v-8.88h1.368zM53.8739,9.664c0,-0.456 -0.096,-0.848 -0.288,-1.176c-0.184,-0.336 -0.432,-0.588 -0.744,-0.756c-0.304,-0.176 -0.632,-0.264 -0.984,-0.264c-0.344,0 -0.672,0.088 -0.984,0.264c-0.304,0.176 -0.552,0.432 -0.744,0.768c-0.184,0.336 -0.276,0.732 -0.276,1.188c0,0.456 0.092,0.856 0.276,1.2c0.192,0.336 0.44,0.592 0.744,0.768c0.312,0.176 0.64,0.264 0.984,0.264c0.352,0 0.68,-0.088 0.984,-0.264c0.312,-0.184 0.56,-0.448 0.744,-0.792c0.192,-0.344 0.288,-0.744 0.288,-1.2zM57.9868,4.12v8.88h-1.368v-8.88zM65.8428,9.532c0,0.248 -0.016,0.472 -0.048,0.672h-5.052c0.04,0.528 0.236,0.952 0.588,1.272c0.352,0.32 0.784,0.48 1.296,0.48c0.736,0 1.256,-0.308 1.56,-0.924h1.476c-0.2,0.608 -0.564,1.108 -1.092,1.5c-0.52,0.384 -1.168,0.576 -1.944,0.576c-0.632,0 -1.2,-0.14 -1.704,-0.42c-0.496,-0.288 -0.888,-0.688 -1.176,-1.2c-0.28,-0.52 -0.42,-1.12 -0.42,-1.8c0,-0.68 0.136,-1.276 0.408,-1.788c0.28,-0.52 0.668,-0.92 1.164,-1.2c0.504,-0.28 1.08,-0.42 1.728,-0.42c0.624,0 1.18,0.136 1.668,0.408c0.488,0.272 0.868,0.656 1.14,1.152c0.272,0.488 0.408,1.052 0.408,1.692zM64.4148,9.1c-0.008,-0.504 -0.188,-0.908 -0.54,-1.212c-0.352,-0.304 -0.788,-0.456 -1.308,-0.456c-0.472,0 -0.876,0.152 -1.212,0.456c-0.336,0.296 -0.536,0.7 -0.6,1.212zM69.8503,9.664c0,-0.664 0.136,-1.252 0.4079,-1.764c0.2801,-0.512 0.6561,-0.908 1.1281,-1.188c0.4799,-0.288 1.0079,-0.432 1.584,-0.432c0.5199,0 0.972,0.104 1.3559,0.312c0.392,0.2 0.7041,0.452 0.9361,0.756v-0.96h1.38v6.612h-1.38v-0.984c-0.232,0.312 -0.5481,0.572 -0.9481,0.78c-0.3999,0.208 -0.8559,0.312 -1.3679,0.312c-0.568,0 -1.088,-0.144 -1.56,-0.432c-0.472,-0.296 -0.848,-0.704 -1.1281,-1.224c-0.2719,-0.528 -0.4079,-1.124 -0.4079,-1.788zM75.2623,9.688c0,-0.456 -0.096,-0.852 -0.288,-1.188c-0.184,-0.336 -0.4281,-0.592 -0.7321,-0.768c-0.304,-0.176 -0.6319,-0.264 -0.984,-0.264c-0.352,0 -0.68,0.088 -0.9839,0.264c-0.304,0.168 -0.552,0.42 -0.744,0.756c-0.184,0.328 -0.2761,0.72 -0.2761,1.176c0,0.456 0.0921,0.856 0.2761,1.2c0.192,0.344 0.44,0.608 0.744,0.792c0.312,0.176 0.64,0.264 0.9839,0.264c0.3521,0 0.68,-0.088 0.984,-0.264c0.304,-0.176 0.5481,-0.432 0.7321,-0.768c0.192,-0.344 0.288,-0.744 0.288,-1.2zM80.8391,13.108c-0.52,0 -0.988,-0.092 -1.404,-0.276c-0.408,-0.192 -0.732,-0.448 -0.972,-0.768c-0.24,-0.328 -0.368,-0.692 -0.384,-1.092h1.416c0.024,0.28 0.156,0.516 0.396,0.708c0.248,0.184 0.556,0.276 0.924,0.276c0.384,0 0.68,-0.072 0.888,-0.216c0.216,-0.152 0.324,-0.344 0.324,-0.576c0,-0.248 -0.12,-0.432 -0.36,-0.552c-0.232,-0.12 -0.604,-0.252 -1.116,-0.396c-0.496,-0.136 -0.9,-0.268 -1.212,-0.396c-0.312,-0.128 -0.584,-0.324 -0.816,-0.588c-0.224,-0.264 -0.336,-0.612 -0.336,-1.044c0,-0.352 0.104,-0.672 0.312,-0.96c0.208,-0.296 0.504,-0.528 0.888,-0.696c0.392,-0.168 0.84,-0.252 1.344,-0.252c0.752,0 1.356,0.192 1.812,0.576c0.464,0.376 0.712,0.892 0.744,1.548h-1.368c-0.024,-0.296 -0.144,-0.532 -0.36,-0.708c-0.216,-0.176 -0.508,-0.264 -0.876,-0.264c-0.36,0 -0.636,0.068 -0.828,0.204c-0.192,0.136 -0.288,0.316 -0.288,0.54c0,0.176 0.064,0.324 0.192,0.444c0.128,0.12 0.284,0.216 0.468,0.288c0.184,0.064 0.456,0.148 0.816,0.252c0.48,0.128 0.872,0.26 1.176,0.396c0.312,0.128 0.58,0.32 0.804,0.576c0.224,0.256 0.34,0.596 0.348,1.02c0,0.376 -0.104,0.712 -0.312,1.008c-0.208,0.296 -0.504,0.528 -0.888,0.696c-0.376,0.168 -0.82,0.252 -1.332,0.252zM87.2492,13.108c-0.52,0 -0.988,-0.092 -1.404,-0.276c-0.408,-0.192 -0.732,-0.448 -0.972,-0.768c-0.24,-0.328 -0.368,-0.692 -0.384,-1.092h1.416c0.024,0.28 0.156,0.516 0.396,0.708c0.248,0.184 0.556,0.276 0.924,0.276c0.384,0 0.68,-0.072 0.888,-0.216c0.216,-0.152 0.324,-0.344 0.324,-0.576c0,-0.248 -0.12,-0.432 -0.36,-0.552c-0.232,-0.12 -0.604,-0.252 -1.116,-0.396c-0.496,-0.136 -0.9,-0.268 -1.212,-0.396c-0.312,-0.128 -0.584,-0.324 -0.816,-0.588c-0.224,-0.264 -0.336,-0.612 -0.336,-1.044c0,-0.352 0.104,-0.672 0.312,-0.96c0.208,-0.296 0.504,-0.528 0.888,-0.696c0.392,-0.168 0.84,-0.252 1.344,-0.252c0.752,0 1.356,0.192 1.812,0.576c0.464,0.376 0.712,0.892 0.744,1.548h-1.368c-0.024,-0.296 -0.144,-0.532 -0.36,-0.708c-0.216,-0.176 -0.508,-0.264 -0.876,-0.264c-0.36,0 -0.636,0.068 -0.828,0.204c-0.192,0.136 -0.288,0.316 -0.288,0.54c0,0.176 0.064,0.324 0.192,0.444c0.128,0.12 0.284,0.216 0.468,0.288c0.184,0.064 0.456,0.148 0.816,0.252c0.48,0.128 0.872,0.26 1.176,0.396c0.312,0.128 0.58,0.32 0.804,0.576c0.224,0.256 0.34,0.596 0.348,1.02c0,0.376 -0.104,0.712 -0.312,1.008c-0.208,0.296 -0.504,0.528 -0.888,0.696c-0.376,0.168 -0.82,0.252 -1.332,0.252zM97.3194,9.532c0,0.248 -0.016,0.472 -0.048,0.672h-5.052c0.04,0.528 0.236,0.952 0.588,1.272c0.352,0.32 0.784,0.48 1.296,0.48c0.736,0 1.256,-0.308 1.56,-0.924h1.476c-0.2,0.608 -0.564,1.108 -1.092,1.5c-0.52,0.384 -1.168,0.576 -1.944,0.576c-0.632,0 -1.2,-0.14 -1.704,-0.42c-0.496,-0.288 -0.888,-0.688 -1.176,-1.2c-0.28,-0.52 -0.42,-1.12 -0.42,-1.8c0,-0.68 0.136,-1.276 0.408,-1.788c0.28,-0.52 0.668,-0.92 1.164,-1.2c0.504,-0.28 1.08,-0.42 1.728,-0.42c0.624,0 1.18,0.136 1.668,0.408c0.488,0.272 0.868,0.656 1.14,1.152c0.272,0.488 0.408,1.052 0.408,1.692zM95.8914,9.1c-0.008,-0.504 -0.188,-0.908 -0.54,-1.212c-0.352,-0.304 -0.788,-0.456 -1.308,-0.456c-0.472,0 -0.876,0.152 -1.212,0.456c-0.336,0.296 -0.536,0.7 -0.6,1.212zM100.262,7.504v3.66c0,0.248 0.056,0.428 0.168,0.54c0.12,0.104 0.32,0.156 0.6,0.156h0.84v1.14h-1.08c-0.616,0 -1.0884,-0.144 -1.4164,-0.432c-0.328,-0.288 -0.492,-0.756 -0.492,-1.404v-3.66h-0.78v-1.116h0.78v-1.644h1.3804v1.644h1.608v1.116zM105.53,13.108c-0.52,0 -0.988,-0.092 -1.404,-0.276c-0.408,-0.192 -0.732,-0.448 -0.972,-0.768c-0.24,-0.328 -0.368,-0.692 -0.384,-1.092h1.416c0.024,0.28 0.156,0.516 0.396,0.708c0.248,0.184 0.556,0.276 0.924,0.276c0.384,0 0.68,-0.072 0.888,-0.216c0.216,-0.152 0.324,-0.344 0.324,-0.576c0,-0.248 -0.12,-0.432 -0.36,-0.552c-0.232,-0.12 -0.604,-0.252 -1.116,-0.396c-0.496,-0.136 -0.9,-0.268 -1.212,-0.396c-0.312,-0.128 -0.584,-0.324 -0.816,-0.588c-0.224,-0.264 -0.336,-0.612 -0.336,-1.044c0,-0.352 0.104,-0.672 0.312,-0.96c0.208,-0.296 0.504,-0.528 0.888,-0.696c0.392,-0.168 0.84,-0.252 1.344,-0.252c0.752,0 1.356,0.192 1.812,0.576c0.464,0.376 0.712,0.892 0.744,1.548h-1.368c-0.024,-0.296 -0.144,-0.532 -0.36,-0.708c-0.216,-0.176 -0.508,-0.264 -0.876,-0.264c-0.36,0 -0.636,0.068 -0.828,0.204c-0.192,0.136 -0.288,0.316 -0.288,0.54c0,0.176 0.064,0.324 0.192,0.444c0.128,0.12 0.284,0.216 0.468,0.288c0.184,0.064 0.456,0.148 0.816,0.252c0.48,0.128 0.872,0.26 1.176,0.396c0.312,0.128 0.58,0.32 0.804,0.576c0.224,0.256 0.34,0.596 0.348,1.02c0,0.376 -0.104,0.712 -0.312,1.008c-0.208,0.296 -0.504,0.528 -0.888,0.696c-0.376,0.168 -0.82,0.252 -1.332,0.252z",
    fillRule: "nonzero",
    fill: "rgb(222, 84, 105)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05i74298466_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,52.5,99.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05i74298466",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05i74298466_stroke_path",
    d: "M0,0c0,0 0,41.644 0,43.9641c0,2.3201 0.3915,4.2857 1.2785,6.4294c0.887,2.1437 2.0008,3.8085 3.6422,5.4499c1.6414,1.6414 3.3062,2.7552 5.4499,3.6422c2.1437,0.887 4.1093,1.2785 6.4294,1.2785c2.3201,0 64.2,0 64.2,0",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq05i74298466_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -82.2,
    y: -61.9641,
    width: 246.60000000000002,
    height: 185.8923,
    fill: "url(#m6eyq05i74298466ps0)",
    mask: "url(#m6eyq05i74298466_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05j50950086_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,133.8003,161.4834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05j50950086",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05j50950086_stroke_path",
    d: "M0,62.8049c0,0 223.8799,0 226.2,0c2.3201,0 4.2857,-0.3915 6.4294,-1.2785c2.1437,-0.887 3.8085,-2.0008 5.4499,-3.6422c1.6414,-1.6414 2.7552,-3.3062 3.6422,-5.4499c0.887,-2.1437 1.2785,-4.1093 1.2785,-6.4294c0,-2.3201 0,-46.0049 0,-46.0049",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq05j50950086_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -244.2,
    y: -64.0049,
    width: 732.5999999999999,
    height: 192.0147,
    fill: "url(#m6eyq05j50950086ps0)",
    mask: "url(#m6eyq05j50950086_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05k62481660_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,135,160.2639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05k62481660",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05k62481660_stroke_path",
    d: "M241.8003,0h-81h-160.8003",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq05k62481660_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -243.00029999999998,
    y: -1.2,
    width: 729.0009,
    height: 3.5999999999999996,
    fill: "url(#m6eyq05k62481660ps0)",
    mask: "url(#m6eyq05k62481660_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05m47869616_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,296,100)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05m47869616",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05m47869616_stroke_path",
    d: "M0,60.5v-60.5",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq05m47869616_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -1.2,
    y: -61.7,
    width: 3.5999999999999996,
    height: 185.10000000000002,
    fill: "url(#m6eyq05m47869616ps0)",
    mask: "url(#m6eyq05m47869616_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6ez8uf044275806_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,53.3999,161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6ez8uf044275806",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6ez8uf044275806_stroke_path",
    d: "M0,63.2877c0,0 142.2799,0 144.6,0c2.3201,0 4.2857,-0.3915 6.4294,-1.2785c2.1437,-0.887 3.8085,-2.0008 5.4499,-3.6422c1.6414,-1.6414 2.7552,-3.3062 3.6422,-5.4499c0.887,-2.1437 1.2785,-4.1093 1.2785,-6.4294c0,-2.3201 0,-46.4877 0,-46.4877",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6ez8uf044275806_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -162.6,
    y: -64.4877,
    width: 487.79999999999995,
    height: 193.4631,
    fill: "url(#m6ez8uf044275806ps0)",
    mask: "url(#m6ez8uf044275806_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05n61225862_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,128.3999,154.7752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05n61225862",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05n61225862_fill_path",
    d: "M10.8,5.4878c0,3.0309 -2.4176,5.4878 -5.4,5.4878c-2.9824,0 -5.4,-2.4569 -5.4,-5.4878c0,-3.0309 2.4176,-5.4878 5.4,-5.4878c2.9824,0 5.4,2.4569 5.4,5.4878z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05o54079572_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,47.3999,218.7996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05o54079572",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05o54079572_fill_path",
    d: "M10.8,5.4878c0,3.0309 -2.4176,5.4878 -5.4,5.4878c-2.9824,0 -5.4,-2.4569 -5.4,-5.4878c0,-3.0309 2.4176,-5.4878 5.4,-5.4878c2.9824,0 5.4,2.4569 5.4,5.4878z",
    fillRule: "nonzero",
    fill: "rgb(222, 84, 105)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05o40975552_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,128.3999,32.2147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05o40975552",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05o40975552_fill_path",
    d: "M10.8,5.4878c0,3.0309 -2.4176,5.4878 -5.4,5.4878c-2.9824,0 -5.4,-2.4569 -5.4,-5.4878c0,-3.0309 2.4176,-5.4878 5.4,-5.4878c2.9824,0 5.4,2.4569 5.4,5.4878z",
    fillRule: "nonzero",
    fill: "rgb(222, 84, 105)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05o49697450_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,209.3999,154.7752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05o49697450",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05o49697450_fill_path",
    d: "M10.8,5.4878c0,3.0309 -2.4176,5.4878 -5.4,5.4878c-2.9824,0 -5.4,-2.4569 -5.4,-5.4878c0,-3.0309 2.4176,-5.4878 5.4,-5.4878c2.9824,0 5.4,2.4569 5.4,5.4878z",
    fillRule: "nonzero",
    fill: "rgb(222, 84, 105)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05p63337178_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,209.3999,93.7996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05p63337178",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05p63337178_fill_path",
    d: "M10.8,5.4878c0,3.0309 -2.4176,5.4878 -5.4,5.4878c-2.9824,0 -5.4,-2.4569 -5.4,-5.4878c0,-3.0309 2.4176,-5.4878 5.4,-5.4878c2.9824,0 5.4,2.4569 5.4,5.4878z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05p70397573_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,47.3999,93.7996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05p70397573",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05p70397573_fill_path",
    d: "M10.8,5.4878c0,3.0309 -2.4176,5.4878 -5.4,5.4878c-2.9824,0 -5.4,-2.4569 -5.4,-5.4878c0,-3.0309 2.4176,-5.4878 5.4,-5.4878c2.9824,0 5.4,2.4569 5.4,5.4878z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05q21708402_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,276,78.5557)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05q21708402",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05q21708402_fill_path",
    d: "M40.2,20.4269c0,11.2817 -8.9988,20.4269 -20.1,20.4269c-11.1012,0 -20.1,-9.1452 -20.1,-20.4269c0,-11.2817 8.9988,-20.4269 20.1,-20.4269c11.1012,0 20.1,9.1452 20.1,20.4269z",
    fillRule: "nonzero",
    fill: "rgb(222, 84, 105)",
    fillOpacity: 0.35,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05q70561274_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,283.2002,85.874)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05q70561274",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05q70561274_fill_path",
    d: "M25.8,13.1098c0,7.2405 -5.7753,13.1098 -12.9,13.1098c-7.1247,0 -12.9,-5.8693 -12.9,-13.1098c0,-7.2405 5.7753,-13.1098 12.9,-13.1098c7.1247,0 12.9,5.8693 12.9,13.1098z",
    fillRule: "nonzero",
    fill: "rgb(222, 84, 105)",
    fillOpacity: 0.28,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05r09407174_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,290.3999,93.7996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05r09407174",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05r09407174_fill_path",
    d: "M10.8,5.4878c0,3.0309 -2.4176,5.4878 -5.4,5.4878c-2.9824,0 -5.4,-2.4569 -5.4,-5.4878c0,-3.0309 2.4176,-5.4878 5.4,-5.4878c2.9824,0 5.4,2.4569 5.4,5.4878z",
    fillRule: "nonzero",
    fill: "rgb(222, 84, 105)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05r06613453_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,371.3999,154.7754)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05r06613453",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05r06613453_fill_path",
    d: "M10.8,5.4878c0,3.0309 -2.4176,5.4878 -5.4,5.4878c-2.9824,0 -5.4,-2.4569 -5.4,-5.4878c0,-3.0309 2.4176,-5.4878 5.4,-5.4878c2.9824,0 5.4,2.4569 5.4,5.4878z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6ezo0jq44542642_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,291,155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6ezo0jq44542642",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6ezo0jq44542642_fill_path",
    d: "M10.8,5.4878c0,3.0309 -2.4176,5.4878 -5.4,5.4878c-2.9824,0 -5.4,-2.4569 -5.4,-5.4878c0,-3.0309 2.4176,-5.4878 5.4,-5.4878c2.9824,0 5.4,2.4569 5.4,5.4878z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05r30186420_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,84.3003,122.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05r30186420",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05r30186420_fill_path",
    d: "M12.8049,0h83.5902c7.07195,0 12.8049,5.73295 12.8049,12.8049v0c0,7.07195 -5.73295,12.8049 -12.8049,12.8049h-83.5902c-7.07195,0 -12.8049,-5.73295 -12.8049,-12.8049v0c0,-7.07195 5.73295,-12.8049 12.8049,-12.8049z",
    fillRule: "nonzero",
    fill: "rgb(3, 105, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6eyq05r30186420_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05r30186420_stroke_path",
    d: "M12.8049,0h83.5902c7.07195,0 12.8049,5.73295 12.8049,12.8049v0c0,7.07195 -5.73295,12.8049 -12.8049,12.8049h-83.5902c-7.07195,0 -12.8049,-5.73295 -12.8049,-12.8049v0c0,-7.07195 5.73295,-12.8049 12.8049,-12.8049z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6eyq05r30186420_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05r30186420_stroke_path",
    d: "M12.8049,0h83.5902c7.07195,0 12.8049,5.73295 12.8049,12.8049v0c0,7.07195 -5.73295,12.8049 -12.8049,12.8049h-83.5902c-7.07195,0 -12.8049,-5.73295 -12.8049,-12.8049v0c0,-7.07195 5.73295,-12.8049 12.8049,-12.8049z",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq05r30186420_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -109.8,
    y: -26.2098,
    width: 329.4,
    height: 78.6294,
    fill: "url(#m6eyq05r30186420ps0)",
    mask: "url(#m6eyq05r30186420_gradient_mask)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05s22939210_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.4,5.6049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05s22939210",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6eyq05s22939210_clipPath",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05s22939210_fill_path",
    d: "M0.01,0h14.38c0.00552,0 0.01,0.00448 0.01,0.01v14.38c0,0.00552 -0.00448,0.01 -0.01,0.01h-14.38c-0.00552,0 -0.01,-0.00448 -0.01,-0.01v-14.38c0,-0.00552 0.00448,-0.01 0.01,-0.01z",
    fill: "white",
    clipRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6eyq05s22939210_clipPath)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05z82689134_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1.2,1.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05z82689134",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05z82689134_stroke_path",
    d: "M12,6c0,-3.31371 -2.68632,-6 -6,-6c-3.31371,0 -6,2.68629 -6,6c0,3.31368 2.68629,6 6,6",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq05z82689134_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.45,0c0,-0.24853 0.20147,-0.45 0.45,-0.45c0.24853,0 0.45,0.20147 0.45,0.45c0,0.24853 -0.20147,0.45 -0.45,0.45c-0.24853,0 -0.45,-0.20147 -0.45,-0.45z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,12,6)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.45,0c0,-0.24853 0.20147,-0.45 0.45,-0.45c0.24853,0 0.45,0.20147 0.45,0.45c0,0.24853 -0.20147,0.45 -0.45,0.45c-0.24853,0 -0.45,-0.20147 -0.45,-0.45z",
    transform: "matrix(1,0,0,1,6,12)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -13.8,
    y: -13.8,
    width: 41.400000000000006,
    height: 41.400000000000006,
    fill: "url(#m6eyq05z82689134ps0)",
    mask: "url(#m6eyq05z82689134_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05z38756217_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,7.8,1.2299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05z38756217",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05z38756217_stroke_path",
    d: "M0,0c0,0 1.8,2.37037 1.8,5.97035",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq05z38756217_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.45,0c0,-0.24853 0.20147,-0.45 0.45,-0.45c0.24853,0 0.45,0.20147 0.45,0.45c0,0.24853 -0.20147,0.45 -0.45,0.45c-0.24853,0 -0.45,-0.20147 -0.45,-0.45z",
    transform: "matrix(-0.6047677682910344,-0.796401874957789,0.796401874957789,-0.6047677682910344,0,0)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.45,0c0,-0.24853 0.20147,-0.45 0.45,-0.45c0.24853,0 0.45,0.20147 0.45,0.45c0,0.24853 -0.20147,0.45 -0.45,0.45c-0.24853,0 -0.45,-0.20147 -0.45,-0.45z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,1.8,5.97035)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -3.6,
    y: -7.7703,
    width: 10.8,
    height: 23.3109,
    fill: "url(#m6eyq05z38756217ps0)",
    mask: "url(#m6eyq05z38756217_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq06072765601_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.8,1.2299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq06072765601",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq06072765601_stroke_path",
    d: "M1.8,11.94077c0,0 -1.8,-2.37042 -1.8,-5.97042c0,-3.59998 1.8,-5.97035 1.8,-5.97035",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq06072765601_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.45,0c0,-0.24853 0.20147,-0.45 0.45,-0.45c0.24853,0 0.45,0.20147 0.45,0.45c0,0.24853 -0.20147,0.45 -0.45,0.45c-0.24853,0 -0.45,-0.20147 -0.45,-0.45z",
    transform: "matrix(0.6047596772777948,0.7964080190071278,-0.7964080190071278,0.6047596772777948,1.8,11.94077)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.45,0c0,-0.24853 0.20147,-0.45 0.45,-0.45c0.24853,0 0.45,0.20147 0.45,0.45c0,0.24853 -0.20147,0.45 -0.45,0.45c-0.24853,0 -0.45,-0.20147 -0.45,-0.45z",
    transform: "matrix(0.6047677682910347,-0.7964018749577887,0.7964018749577887,0.6047677682910347,1.8,8.881784197001252e-16)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -3.6,
    y: -13.7408,
    width: 10.8,
    height: 41.2224,
    fill: "url(#m6eyq06072765601ps0)",
    mask: "url(#m6eyq06072765601_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq06120475574_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1.5773,9.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq06120475574",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq06120475574_stroke_path",
    d: "M0,0h5.62222",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq06120475574_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.45,0c0,-0.24853 0.20147,-0.45 0.45,-0.45c0.24853,0 0.45,0.20147 0.45,0.45c0,0.24853 -0.20147,0.45 -0.45,0.45c-0.24853,0 -0.45,-0.20147 -0.45,-0.45z",
    transform: "matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,0,0)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.45,0c0,-0.24853 0.20147,-0.45 0.45,-0.45c0.24853,0 0.45,0.20147 0.45,0.45c0,0.24853 -0.20147,0.45 -0.45,0.45c-0.24853,0 -0.45,-0.20147 -0.45,-0.45z",
    transform: "matrix(1,0,0,1,5.62222,0)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -7.4222,
    y: -1.8,
    width: 22.2666,
    height: 5.4,
    fill: "url(#m6eyq06120475574ps0)",
    mask: "url(#m6eyq06120475574_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq06271689179_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1.5773,5.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq06271689179",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq06271689179_stroke_path",
    d: "M0,0h11.24446",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq06271689179_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.45,0c0,-0.24853 0.20147,-0.45 0.45,-0.45c0.24853,0 0.45,0.20147 0.45,0.45c0,0.24853 -0.20147,0.45 -0.45,0.45c-0.24853,0 -0.45,-0.20147 -0.45,-0.45z",
    transform: "matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,0,0)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.45,0c0,-0.24853 0.20147,-0.45 0.45,-0.45c0.24853,0 0.45,0.20147 0.45,0.45c0,0.24853 -0.20147,0.45 -0.45,0.45c-0.24853,0 -0.45,-0.20147 -0.45,-0.45z",
    transform: "matrix(1,0,0,1,11.24446,0)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -13.044500000000001,
    y: -1.8,
    width: 39.133500000000005,
    height: 5.4,
    fill: "url(#m6eyq06271689179ps0)",
    mask: "url(#m6eyq06271689179_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq06247275202_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,9.4781,8.7316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq06247275202",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq06247275202_stroke_path",
    d: "M3.64938,2.0191c0.29628,0.18222 0.27804,0.6258 -0.02712,0.66042l-1.53996,0.17454l-0.69072,1.38738c-0.13686,0.27492 -0.55992,0.14034 -0.62988,-0.2004l-0.75318,-3.6696c-0.0591,-0.288 0.19974,-0.46926 0.45012,-0.31518z",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 0.9,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6eyq06247275202_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -5.6617,
    y: -6.1887,
    width: 16.9851,
    height: 18.5661,
    fill: "url(#m6eyq06247275202ps0)",
    mask: "url(#m6eyq06247275202_gradient_mask)"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05s17432881_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,34.8,5.8049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6eyq05s17432881",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6eyq05s17432881_fill_path",
    d: "M3.36037,10.0672c-0.4672,0 -0.8896,-0.08 -1.2672,-0.24c-0.3712,-0.16 -0.6656,-0.3904 -0.8832,-0.6912c-0.2176,-0.3008 -0.3296,-0.656 -0.336,-1.0656h1.44c0.0192,0.2752 0.1152,0.4928 0.288,0.6528c0.1792,0.16 0.4224,0.24 0.7296,0.24c0.3136,0 0.56,-0.0736 0.7392,-0.2208c0.1792,-0.1536 0.2688,-0.352 0.2688,-0.5952c0,-0.1984 -0.0608,-0.3616 -0.1824,-0.4896c-0.1216,-0.128 -0.2752,-0.2272 -0.4608,-0.2976c-0.1792,-0.0768 -0.4288,-0.16 -0.7488,-0.2496c-0.4352,-0.128 -0.7904,-0.2528 -1.0656,-0.3744c-0.2688,-0.128 -0.5024,-0.3168 -0.7008,-0.5664c-0.192,-0.256 -0.288,-0.5952 -0.288,-1.0176c0,-0.3968 0.0992,-0.7424 0.2976,-1.0368c0.1984,-0.2944 0.4768,-0.5184 0.8352,-0.672c0.3584,-0.16 0.768,-0.24 1.2288,-0.24c0.6912,0 1.2512,0.1696 1.68,0.5088c0.4352,0.3328 0.6752,0.8 0.72,1.4016h-1.4784c-0.0128,-0.2304 -0.112,-0.4192 -0.2976,-0.5664c-0.1792,-0.1536 -0.4192,-0.2304 -0.72,-0.2304c-0.2624,0 -0.4736,0.0672 -0.6336,0.2016c-0.1536,0.1344 -0.2304,0.3296 -0.2304,0.5856c0,0.1792 0.0576,0.3296 0.1728,0.4512c0.1216,0.1152 0.2688,0.2112 0.4416,0.288c0.1792,0.0704 0.4288,0.1536 0.7488,0.2496c0.4352,0.128 0.7904,0.256 1.0656,0.384c0.2752,0.128 0.512,0.32 0.7104,0.576c0.1984,0.256 0.2976,0.592 0.2976,1.008c0,0.3584 -0.0928,0.6912 -0.2784,0.9984c-0.1856,0.3072 -0.4576,0.5536 -0.816,0.7392c-0.3584,0.1792 -0.784,0.2688 -1.2768,0.2688zM11.8408,7.2256c0,0.192 -0.0128,0.3648 -0.0384,0.5184h-3.88803c0.032,0.384 0.1664,0.6848 0.4032,0.9024c0.2368,0.2176 0.528,0.3264 0.8736,0.3264c0.4992,0 0.85443,-0.2144 1.06563,-0.6432h1.4496c-0.1536,0.512 -0.448,0.9344 -0.8832,1.2672c-0.4352,0.3264 -0.96963,0.4896 -1.60323,0.4896c-0.512,0 -0.9728,-0.112 -1.3824,-0.336c-0.4032,-0.2304 -0.72,-0.5536 -0.9504,-0.9696c-0.224,-0.416 -0.336,-0.896 -0.336,-1.44c0,-0.5504 0.112,-1.0336 0.336,-1.4496c0.224,-0.416 0.5376,-0.736 0.9408,-0.96c0.4032,-0.224 0.8672,-0.336 1.392,-0.336c0.5056,0 0.95683,0.1088 1.35363,0.3264c0.4032,0.2176 0.7136,0.528 0.9312,0.9312c0.224,0.3968 0.336,0.8544 0.336,1.3728zM10.4488,6.8416c-0.0064,-0.3456 -0.1312,-0.6208 -0.3744,-0.8256c-0.24323,-0.2112 -0.54083,-0.3168 -0.89283,-0.3168c-0.3328,0 -0.6144,0.1024 -0.8448,0.3072c-0.224,0.1984 -0.3616,0.4768 -0.4128,0.8352zM12.4762,7.3408c0,-0.5504 0.112,-1.0304 0.336,-1.44c0.224,-0.416 0.5344,-0.736 0.9312,-0.96c0.3968,-0.2304 0.8512,-0.3456 1.3632,-0.3456c0.6592,0 1.2032,0.1664 1.632,0.4992c0.4352,0.3264 0.7264,0.7872 0.8736,1.3824h-1.4496c-0.0768,-0.2304 -0.208,-0.4096 -0.3936,-0.5376c-0.1792,-0.1344 -0.4032,-0.2016 -0.672,-0.2016c-0.384,0 -0.688,0.1408 -0.912,0.4224c-0.224,0.2752 -0.336,0.6688 -0.336,1.1808c0,0.5056 0.112,0.8992 0.336,1.1808c0.224,0.2752 0.528,0.4128 0.912,0.4128c0.544,0 0.8992,-0.2432 1.0656,-0.7296h1.4496c-0.1472,0.576 -0.4384,1.0336 -0.8736,1.3728c-0.4352,0.3392 -0.9792,0.5088 -1.632,0.5088c-0.512,0 -0.9664,-0.112 -1.3632,-0.336c-0.3968,-0.2304 -0.7072,-0.5504 -0.9312,-0.96c-0.224,-0.416 -0.336,-0.8992 -0.336,-1.4496zM23.6176,4.6816v5.3184h-1.3536v-0.672c-0.1728,0.2304 -0.4,0.4128 -0.6816,0.5472c-0.2752,0.128 -0.576,0.192 -0.9024,0.192c-0.416,0 -0.784,-0.0864 -1.104,-0.2592c-0.32,-0.1792 -0.5728,-0.4384 -0.7584,-0.7776c-0.1792,-0.3456 -0.2688,-0.7552 -0.2688,-1.2288v-3.12h1.344v2.928c0,0.4224 0.1056,0.7488 0.3168,0.9792c0.2112,0.224 0.4992,0.336 0.864,0.336c0.3712,0 0.6624,-0.112 0.8736,-0.336c0.2112,-0.2304 0.3168,-0.5568 0.3168,-0.9792v-2.928zM26.2876,5.5072c0.1728,-0.2816 0.3968,-0.5024 0.672,-0.6624c0.2816,-0.16 0.6016,-0.24 0.96,-0.24v1.4112h-0.3552c-0.4224,0 -0.7424,0.0992 -0.96,0.2976c-0.2112,0.1984 -0.3168,0.544 -0.3168,1.0368v2.6496h-1.344v-5.3184h1.344zM33.7689,7.2256c0,0.192 -0.0128,0.3648 -0.0384,0.5184h-3.888c0.032,0.384 0.1664,0.6848 0.4032,0.9024c0.2368,0.2176 0.528,0.3264 0.8736,0.3264c0.4992,0 0.8544,-0.2144 1.0656,-0.6432h1.4496c-0.1536,0.512 -0.448,0.9344 -0.8832,1.2672c-0.4352,0.3264 -0.9696,0.4896 -1.6032,0.4896c-0.512,0 -0.9728,-0.112 -1.3824,-0.336c-0.4032,-0.2304 -0.72,-0.5536 -0.9504,-0.9696c-0.224,-0.416 -0.336,-0.896 -0.336,-1.44c0,-0.5504 0.112,-1.0336 0.336,-1.4496c0.224,-0.416 0.5376,-0.736 0.9408,-0.96c0.4032,-0.224 0.8672,-0.336 1.392,-0.336c0.5056,0 0.9568,0.1088 1.3536,0.3264c0.4032,0.2176 0.7136,0.528 0.9312,0.9312c0.224,0.3968 0.336,0.8544 0.336,1.3728zM32.3769,6.8416c-0.0064,-0.3456 -0.1312,-0.6208 -0.3744,-0.8256c-0.2432,-0.2112 -0.5408,-0.3168 -0.8928,-0.3168c-0.3328,0 -0.6144,0.1024 -0.8448,0.3072c-0.224,0.1984 -0.3616,0.4768 -0.4128,0.8352zM36.6918,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.512,-0.736 0.8832,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3456,0 0.6752,0.0768 0.9888,0.2304c0.3136,0.1472 0.5632,0.3456 0.7488,0.5952v-2.5248h1.3632v7.104h-1.3632v-0.7872c-0.1664,0.2624 -0.4,0.4736 -0.7008,0.6336c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3712,-0.2304 -0.6656,-0.5536 -0.8832,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM40.8774,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448zM43.198,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.5088,-0.736 0.8736,-0.96c0.3712,-0.224 0.784,-0.336 1.2385,-0.336c0.3967,0 0.7423,0.08 1.0368,0.24c0.3007,0.16 0.5407,0.3616 0.7199,0.6048v-0.7584h1.3536v5.3184h-1.3536v-0.7776c-0.1728,0.2496 -0.4128,0.4576 -0.7199,0.624c-0.3008,0.16 -0.6497,0.24 -1.0465,0.24c-0.4479,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3648,-0.2304 -0.656,-0.5536 -0.8736,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM47.3836,7.3408c0,-0.3264 -0.064,-0.6048 -0.1919,-0.8352c-0.1281,-0.2368 -0.3008,-0.416 -0.5185,-0.5376c-0.2175,-0.128 -0.4512,-0.192 -0.7007,-0.192c-0.2497,0 -0.4801,0.0608 -0.6913,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.1919,0.5056 -0.1919,0.8256c0,0.32 0.0639,0.6016 0.1919,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6913,0.192c0.2495,0 0.4832,-0.0608 0.7007,-0.1824c0.2177,-0.128 0.3904,-0.3072 0.5185,-0.5376c0.1279,-0.2368 0.1919,-0.5184 0.1919,-0.8448zM51.6147,5.7856v2.5728c0,0.1792 0.0416,0.3104 0.1248,0.3936c0.0896,0.0768 0.2368,0.1152 0.4416,0.1152h0.624v1.1328h-0.8448c-1.1328,0 -1.6992,-0.5504 -1.6992,-1.6512v-2.5632h-0.6336v-1.104h0.6336v-1.3152h1.3536v1.3152h1.1904v1.104zM53.4262,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.5088,-0.736 0.8736,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3968,0 0.7424,0.08 1.0368,0.24c0.3008,0.16 0.5408,0.3616 0.72,0.6048v-0.7584h1.3536v5.3184h-1.3536v-0.7776c-0.1728,0.2496 -0.4128,0.4576 -0.72,0.624c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3648,-0.2304 -0.656,-0.5536 -0.8736,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM57.6118,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }))))))))))))))))), _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    href: "#m6ezn4az22456317_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 82.315;0 82.315;0 82.315;0 82.315;0 82.315;0 82.315;0 82.315;0 82.315;0 82.315;0 82.315;0 82.315;0 82.315;0 82.315;39.3971 42.9179;81.5 0.815;81.5 0.815;81.5 0.815;81.5 0.815;81.5 0.815;81.5 0.815;81.5 0.815;81.5 0.815;81.5 0.815;81.5 0.815;81.5 0.815;81.5 0.815",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6ezn4az22456317_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate3 || (_animate3 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6ezdnar98836800_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 134.1319;0 134.1319;0 134.1319;0 134.1319;0 134.1319;0 134.1319;0 134.1319;0 134.1319;29.6551 104.4768;66.7472 67.3847;109.032 25.0999;132.8039 1.328;132.8039 1.328;132.8039 1.328;132.8039 1.328;132.8039 1.328;132.8039 1.328;132.8039 1.328;132.8039 1.328;132.8039 1.328;132.8039 1.328;132.8039 1.328;132.8039 1.328;132.8039 1.328;132.8039 1.328;132.8039 1.328",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate4 || (_animate4 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6ezdnar98836800_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate5 || (_animate5 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6eyq05a56317117",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.47;0.55;1",
    keySplines: "0.5 0.45 0.15 1;0.5 0.45 0.5 0.58;0.5 0.35 0.5 0.58",
    additive: "replace",
    fill: "freeze"
  })), _animate6 || (_animate6 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6eyq05i74298466_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 135.9136;0 135.9136;0 135.9136;0 135.9136;30.4527 105.4609;66.2478 69.6658;100.9529 34.9608;131.3787 4.5349;134.568 1.3457;134.568 1.3457;134.568 1.3457;134.568 1.3457;134.568 1.3457;134.568 1.3457;134.568 1.3457;134.568 1.3457;134.568 1.3457;134.568 1.3457;134.568 1.3457;134.568 1.3457;134.568 1.3457;134.568 1.3457;134.568 1.3457;134.568 1.3457;134.568 1.3457;134.568 1.3457",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate7 || (_animate7 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6eyq05i74298466_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "-134.568;-134.568;-134.568;-134.568;-104.1152;-68.3201;-33.6151;-3.1893;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate8 || (_animate8 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6eyq05j50950086_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 301.5948;0 301.5948;0 301.5948;0 301.5948;0 301.5948;0 301.5948;0 301.5948;0 301.5948;0 301.5948;0 301.5948;0 301.5948;0 301.5948;32.7872 268.8076;151.6932 149.9016;259.8792 41.7156;289.5609 12.0339;298.1011 3.4937;298.6088 2.9861;298.6088 2.9861;298.6088 2.9861;298.6088 2.9861;298.6088 2.9861;298.6088 2.9861;298.6088 2.9861;298.6088 2.9861;298.6088 2.9861",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate9 || (_animate9 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6eyq05j50950086_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "-298.6088;-298.6088;-298.6088;-298.6088;-298.6088;-298.6088;-298.6088;-298.6088;-298.6088;-298.6088;-298.6088;-298.6088;-265.8215;-146.9155;-38.7296;-9.0478;-0.5076;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate10 || (_animate10 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6eyq05k62481660_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 244.2183;0 244.2183;0 244.2183;0 244.2183;28.4599 215.7584;60.0874 184.1309;93.2866 150.9317;127.7431 116.4752;161.4259 82.7924;193.0775 51.1408;223.1091 21.1092;241.8003 2.418;241.8003 2.418;241.8003 2.418;241.8003 2.418;241.8003 2.418;241.8003 2.418;241.8003 2.418;241.8003 2.418;241.8003 2.418;241.8003 2.418;241.8003 2.418;241.8003 2.418;241.8003 2.418;241.8003 2.418;241.8003 2.418",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate11 || (_animate11 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6eyq05k62481660_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "-241.8003;-241.8003;-241.8003;-241.8003;-213.3404;-181.7129;-148.5137;-114.0572;-80.3744;-48.7228;-18.6912;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate12 || (_animate12 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6eyq05m47869616_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 61.105;0 61.105;0 61.105;0 61.105;0 61.105;0 61.105;0 61.105;0 61.105;0 61.105;45.611 15.4941;60.2822 0.8228;60.5 0.605;60.5 0.605;60.5 0.605;60.5 0.605;60.5 0.605;60.5 0.605;60.5 0.605;60.5 0.605;60.5 0.605;60.5 0.605;60.5 0.605;60.5 0.605;60.5 0.605;60.5 0.605;60.5 0.605",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate13 || (_animate13 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6eyq05m47869616_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate14 || (_animate14 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6ez8uf044275806_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 219.6665;0 219.6665;0 219.6665;0 219.6665;0 219.6665;0 219.6665;0 219.6665;65.3345 154.332;169.7087 49.9578;217.4916 2.1749;217.4916 2.1749;217.4916 2.1749;217.4916 2.1749;217.4916 2.1749;217.4916 2.1749;217.4916 2.1749;217.4916 2.1749;217.4916 2.1749;217.4916 2.1749;217.4916 2.1749;217.4916 2.1749;217.4916 2.1749;217.4916 2.1749;217.4916 2.1749;217.4916 2.1749;217.4916 2.1749",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate15 || (_animate15 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6ez8uf044275806_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "-217.4916;-217.4916;-217.4916;-217.4916;-217.4916;-217.4916;-217.4916;-152.1571;-47.7829;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate16 || (_animate16 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6eyq05n61225862",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.06;0.12;1",
    keySplines: "0.54 0.51 0.15 1;0.54 0.51 0.47 0.53;0.5 0.35 0.47 0.53",
    additive: "replace",
    fill: "freeze"
  })), _animate17 || (_animate17 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6eyq05o54079572",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.34;0.38;1",
    keySplines: "0.5 0.49 0.15 1;0.5 0.49 0.49 0.51;0.5 0.35 0.49 0.51",
    additive: "replace",
    fill: "freeze"
  })), _animate18 || (_animate18 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6eyq05o40975552",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.41;0.44;1",
    keySplines: "0.48 0.4 0.15 1;0.48 0.4 0.39 0.53;0.5 0.35 0.39 0.53",
    additive: "replace",
    fill: "freeze"
  })), _animate19 || (_animate19 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6eyq05o49697450",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.22;0.24;1",
    keySplines: "0.49 0.45 0.15 1;0.49 0.45 0.47 0.49;0.5 0.35 0.47 0.49",
    additive: "replace",
    fill: "freeze"
  })), _animate20 || (_animate20 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6eyq05p63337178",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.54;0.58;1",
    keySplines: "0.53 0.5 0.15 1;0.53 0.5 0.47 0.57;0.5 0.35 0.47 0.57",
    additive: "replace",
    fill: "freeze"
  })), _animate21 || (_animate21 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6eyq05p70397573",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.27;0.3;1",
    keySplines: "0.48 0.45 0.15 1;0.48 0.45 0.41 0.52;0.5 0.35 0.41 0.52",
    additive: "replace",
    fill: "freeze"
  })), _animate22 || (_animate22 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6eyq05q21708402",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.44;0.5;1",
    keySplines: "0.51 0.48 0.15 1;0.51 0.48 0.48 0.56;0.5 0.35 0.48 0.56",
    additive: "replace",
    fill: "freeze"
  })), _animate23 || (_animate23 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6eyq05q70561274",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.42;0.47;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate24 || (_animate24 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6eyq05r09407174",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.36;0.41;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate25 || (_animate25 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6eyq05r06613453",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.41;0.46;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate26 || (_animate26 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6ezo0jq44542642",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.31;0.34;1",
    keySplines: "0.45 0.43 0.15 1;0.45 0.43 0.46 0.59;0.5 0.35 0.46 0.59",
    additive: "replace",
    fill: "freeze"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrioritizationMotion);
export default __webpack_public_path__ + "static/media/Prioritization-motion.41a5a70b5bf9e2ef7cff56c0758e49a1.svg";
export { ForwardRef as ReactComponent };